/*
 * Payment emails "Download CSV": what was sent, when and how it went; never who it went to (no
 * To / Copy addresses) and no address inside a failure sentence. Pure; csv.test.js.
 */
import { csv_file_name } from '../../../util_components/csv_export/to_csv';
import { bare } from '../payouts/csv';

export const payment_emails_csv_name = () =>
  csv_file_name({ page: 'Payment emails', table: 'History' });

const ADDRESS_RE = /[^\s<>()"',;:]+@[^\s<>()"',;:]+\.[^\s<>()"',;:]+/g;

// A server sentence such as "a@b.com bounced" keeps its meaning without the address.
export const redact_addresses = (text) =>
  typeof text === 'string' ? text.replace(ADDRESS_RE, '[address removed]') : text;

// outbox_view rows. Headers avoid the word "email": the export refuses PII-looking columns.
export const OUTBOX_COLUMNS = [
  { header: 'Message ID', key: 'uuid' },
  { header: 'Teacher', value: (r) => bare(r.teacher_name) },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Message type', value: (r) => bare(r.kind_label) },
  { header: 'Pay month', key: 'pay_month' },
  { header: 'Subject', key: 'subject' },
  { header: 'Status', key: 'status_label' },
  { header: 'Status detail', value: (r) => redact_addresses(r.status_reason) },
  { header: 'Status note', value: (r) => redact_addresses(r.status_note) },
  { header: 'Test inboxes only', key: 'is_test', kind: 'bool' },
  { header: 'Attempts', key: 'attempts', kind: 'number' },
  { header: 'Queued at (IST)', value: (r) => bare(r.created_at), kind: 'datetime' },
  { header: 'Sent at (IST)', value: (r) => bare(r.sent_at), kind: 'datetime' },
  { header: 'Next try (IST)', value: (r) => bare(r.next_attempt_at), kind: 'datetime' }
];
